import { AmountTypeEnum } from "api";

export const amountTypeLabels: Record<AmountTypeEnum, string> = {
  [AmountTypeEnum.MerchantDefined]: "Фіксована сума",
  [AmountTypeEnum.PayerDefined]: "Суму вводить платник",
};
